// extracted by mini-css-extract-plugin
export default {"modal":"ModalConfirmation_modal__0T37x","crossButton":"ModalConfirmation_crossButton__Hc14R"};